import React from "react";

function PrimaryButton(props) {
  return (
    <a
      className="btn btn-black"
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.children}
    </a>
  );
}

function SecondaryButton(props) {
  return (
    <a
      className="btn btn-social"
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.children}
    </a>
  );
}

/*
  Generic button for new UI
  @param {function} onClick - callback for button click
  @param {component} children - children of the button
  @param {boolean} outlined - if button is outlined
  @param {boolean} isBold - if button is bold

*/
function NewButton({
  onClick,
  children,
  outlined = true,
  disabled = false,
  isBold = true,
  className = "",
  autoWidth = true,
  style = {},
}) {
  return (
    <button
      disabled={disabled}
      className={`${className} btn  ${
        outlined ? "btn-newui-outlined" : "btn-newui"
      } ${autoWidth ? "btn-auto-width" : ""}`}
      style={{
        fontWeight: isBold ? "bold" : "normal",
        ...style,
      }}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

export { NewButton, PrimaryButton, SecondaryButton };

